"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function descriptionIsObject(description) {
    return typeof description === 'object' && description.text;
}
exports.descriptionIsObject = descriptionIsObject;
//# sourceMappingURL=page-header.js.map